import { render, staticRenderFns } from "./AdminSubzones.vue?vue&type=template&id=4b8744a3&"
import script from "./AdminSubzones.vue?vue&type=script&lang=js&"
export * from "./AdminSubzones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports